"use client";
import { useState } from "react";
import Carousel from "react-multi-carousel";
import { PROVIDER_TESTIMONIAL } from "../../../data/testimonals";
import Image from "next/image";

const Testimonials2 = () => {
  const [carouselConfig, setCarouselConfig] = useState({
    showDots: true,
    showArrow: true,
  });

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1497 },
      items: 1,
      slidesToSlide: 1,
    },
    semitablet: {
      breakpoint: { max: 1496, min: 1081 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1080, min: 721 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 720, min: 481 },
      items: 1,
      slidesToSlide: 1,
    },
    mobileSmall: {
      breakpoint: { max: 480, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div className="sliders pos-rel ">
      <Carousel
        swipeable
        draggable={false}
        arrows={false}
        showDots={true}
        responsive={responsive}
        renderDotsOutside
        ssr={true}
        infinite={true}
        removeArrowOnDeviceType={[]}
        autoPlay={true}
        autoPlaySpeed={60000}
        partialVisible={true}
      >
        {PROVIDER_TESTIMONIAL.map((i) => (
          <div
            className="slider-one "
            style={{
              padding: "0 10px",
            }}
            key={i}
          >
            <div className="flex row b-r-10">
              <div className=" top font-robo italic l-h-1-5 medium f-w-400">
                {`" ${i.content}"`}
              </div>
              <div className="bottom">
                <div className="flex" style={{ gap: "10px" }}>
                  <div className="">
                    {/* <img
                      style={{
                        borderRadius: "50%",
                      }}
                      src={i.image}
                      alt={i.name}
                    /> */}
                    <Image
                     style={{
                      borderRadius: "50%",
                    }}
                      // className="b-r-10"
                      src={i.image}
                      alt={i.name}
                      width={500} // set your preferred width
                      height={300} // set your preferred height
                    />
                  </div>
                  <div className="flex center-left">
                    <div className=" ">
                      <h6 className="p-14 t-t-u f-w-700 ">{i.name}</h6>
                      <p className="p-14 t-t-u f-w-500 color-dark-blue">
                        {i.info}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Testimonials2;
